<template>
    <Breakpoints v-if="!isTunnelView">
        <MobilePageHeader slot="max-sm"/>
        <DesktopPageHeader slot="min-md"/>
    </Breakpoints>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import appStore from '@/core/app/app.store';
import MobilePageHeader from '@/project/layout/page-header/mobile/MobilePageHeader.vue';
import DesktopPageHeader from '@/project/layout/page-header/desktop/DesktopPageHeader.vue';

const isTunnelView = computed((): boolean => {
    return appStore.isTunnelView;
});
</script>
